// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-v"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 5L16 14.2732C16 14.5047 15.9196 14.7291 15.7727 14.908L12 19.5L8.22733 14.908C8.08035 14.7291 8 14.5047 8 14.2732L8.00001 5","stroke-linecap":"square","strokeLinejoin":"bevel","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-v')
export default class LettersVIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-v',
    }
  }
}
